import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.406 4.75c.356 0 .657.3.657.656 0 .465.19.657.628 1.04l.028.027c.437.382 1.094.957 1.094 1.996 0 .383-.301.656-.657.656a.63.63 0 0 1-.656-.656c0-.438-.219-.63-.656-1.012l-.028-.027C7.38 7.047 6.75 6.473 6.75 5.406c0-.355.273-.656.656-.656M5.875 10h10.063C17.605 10 19 11.395 19 13.063a3.075 3.075 0 0 1-3.062 3.062H15.5a2.626 2.626 0 0 1-2.625 2.625h-5.25A2.626 2.626 0 0 1 5 16.125v-5.25c0-.465.383-.875.875-.875m9.625 1.75v2.625h.438c.71 0 1.312-.574 1.312-1.312a1.33 1.33 0 0 0-1.312-1.313zm-4.375-6.344c0 .465.191.657.629 1.04l.027.027c.438.382 1.094.957 1.094 1.996 0 .383-.3.656-.656.656a.63.63 0 0 1-.656-.656c0-.438-.22-.63-.657-1.012l-.027-.027c-.438-.383-1.066-.957-1.066-2.024 0-.355.273-.656.656-.656.355 0 .656.3.656.656"
    }, null, -1)
  ]))]))
}
export default { render: render }